import { getCompanyId, getUserId } from "@/utils/userUtils";
import {
  getStoredSelectedResourceId,
  selectAvailableResourceId,
  setStoredSelectedResourceId,
} from "@/utils/selectedResourceUtils";

const STORAGE_KEY_PREFIX = "edo.selectedSabyIntegrationId";

/**
 * Строит ключ localStorage отдельно для компании и пользователя, чтобы выбор
 * кабинета ЭДО не переносился между разными рабочими контекстами.
 */
function storageKey(companyId = getCompanyId(), userId = getUserId()) {
  return `${STORAGE_KEY_PREFIX}.${companyId || "current"}.${userId || "user"}`;
}

// Возвращает сохранённый ID кабинета для текущей компании и пользователя.
export function getSelectedSabyIntegrationId(
  companyId = getCompanyId(),
  userId = getUserId()
) {
  return getStoredSelectedResourceId(storageKey(companyId, userId));
}

// Сохраняет выбранный кабинет или очищает выбор, если integrationId пустой.
export function setSelectedSabyIntegrationId(
  integrationId,
  companyId = getCompanyId(),
  userId = getUserId()
) {
  setStoredSelectedResourceId(
    storageKey(companyId, userId),
    integrationId
  );
}

// При открытии ЭДО ссылка на конкретный кабинет имеет приоритет над сохранённым
// выбором. Оба значения проверяем по списку доступных кабинетов, чтобы не
// восстановить отключённую или удалённую интеграцию. Если валидного выбора нет,
// открываем первый доступный кабинет.
export function selectSabyIntegrationId({
  routeIntegrationId = null,
  savedIntegrationId = null,
  integrations = [],
}) {
  return selectAvailableResourceId({
    routeResourceId: routeIntegrationId,
    savedResourceId: savedIntegrationId,
    resources: integrations,
    fallbackId: integrations[0]?.id || null,
  });
}
